import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { LineItemRefundDTOBase } from "./LineItemRefundDTOBase";
import type { LineItemRefundTaxStaff } from "./LineItemRefundTaxStaff";
import type { LineItemStaff } from "./LineItemStaff";
import type { OrderRefundStaff } from "./OrderRefundStaff";
import type { TrackedModernBase } from "./TrackedModernBase";

export class LineItemRefundStaff implements LineItemRefundDTOBase, TrackedModernBase {
  constructor(public readonly assignId: number, public readonly amountPreTaxCents: number | null, public readonly amountTaxesCents: number | null, public readonly amountRefundedCents: number | null, public readonly refundQuantity: number | null, public readonly revokeDuring: boolean | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly lineItemId: LineItemStaff | null, public readonly taxes: Array<LineItemRefundTaxStaff> | null, public readonly orderRefundId: OrderRefundStaff | null) {
    this.cbiServiceContext = null;
    this.lineItemIdLoaded = this.lineItemId != null;
    this.lineItemIdCached = this.lineItemId;
    this.taxesLoaded = this.taxes != null;
    this.taxesCached = this.taxes;
    this.orderRefundIdLoaded = this.orderRefundId != null;
    this.orderRefundIdCached = this.orderRefundId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private lineItemIdLoaded: boolean;
  private lineItemIdCached: LineItemStaff | null;
  private taxesLoaded: boolean;
  private taxesCached: Array<LineItemRefundTaxStaff> | null;
  private orderRefundIdLoaded: boolean;
  private orderRefundIdCached: OrderRefundStaff | null;
  async lineItemIdLazy(): Promise<LineItemStaff | null> {
    if (!this.lineItemIdLoaded) {
      this.lineItemIdCached = await this.cbiServiceContext!.orderService().getLineItemRefundStaffLineItemId(this.assignId);
      this.lineItemIdLoaded = true;
    }
    return this.lineItemIdCached;
  }
  async taxesLazy(): Promise<Array<LineItemRefundTaxStaff>> {
    if (!this.taxesLoaded) {
      this.taxesCached = await this.cbiServiceContext!.orderService().getLineItemRefundStaffTaxes(this.assignId);
      this.taxesLoaded = true;
    }
    return this.taxesCached!;
  }
  async orderRefundIdLazy(): Promise<OrderRefundStaff | null> {
    if (!this.orderRefundIdLoaded) {
      this.orderRefundIdCached = await this.cbiServiceContext!.orderService().getLineItemRefundStaffOrderRefundId(this.assignId);
      this.orderRefundIdLoaded = true;
    }
    return this.orderRefundIdCached;
  }
}
